import React from 'react';
import {
  Box,
  Stack,
  Paper,
} from '@fortress-technology-solutions/fortress-component-library/Atoms';
import { APP_BAR_HEIGHT } from '../TableLayout/constants';

const ProfileLayout = ({
  ContactBox,
  ResidentTransferCard,
  Household,
  Waitlist,
  Snapshot,
  Tabs,
  TabsContent,
}) => {
  return (
    <Box
      id={'profile-layout'}
      padding={2}
      height={{ xs: 'auto', lg: `calc(100dvh - ${APP_BAR_HEIGHT}px)` }}
      width={'100%'}
      component="div"
      display={'grid'}
      gridTemplateColumns={{ xs: '1fr', lg: '450px 1fr' }}
      gridTemplateRows={{ xs: 'auto auto', lg: '1fr' }}
      gap={2}
      overflow={{ xs: 'visible', lg: 'hidden' }}
      sx={{ minWidth: 0, overflowX: 'hidden' }}
    >
      <Box
        id={'profile-layout_left-panel-container'}
        gridColumn={1}
        sx={{
          overflowY: { xs: 'visible', lg: 'auto' },
          minHeight: 0,
          minWidth: 0,
        }}
      >
        <Stack id={'profile-layout_left-panel'} gap={2} paddingY={'1px'}>
          <Paper>{ContactBox}</Paper>
          {Waitlist && <Paper>{Waitlist}</Paper>}
          {ResidentTransferCard}
          <Paper>{Snapshot}</Paper>
          <Paper>{Household}</Paper>
        </Stack>
      </Box>

      <Paper
        id={'profile-layout_tabs-container'}
        sx={{
          gridColumn: { xs: 1, lg: 2 },
          display: 'flex',
          flexDirection: 'column',
          overflow: { xs: 'visible', lg: 'hidden' },
          minHeight: 0,
          minWidth: 0,
        }}
      >
        <Box id={'profile-layout_tabs'} flexShrink={0}>
          {Tabs}
        </Box>
        <Box
          id={'profile-layout_tabs-content'}
          px={2}
          pb={2}
          pt={0}
          flex={1}
          overflow={{ xs: 'visible', lg: 'auto' }}
          minHeight={0}
          minWidth={0}
          sx={{ overflowX: 'hidden' }}
        >
          {TabsContent}
        </Box>
      </Paper>
    </Box>
  );
};

export default ProfileLayout;
